import {notify} from '@gemcook/notification';

import paths from '@paths';
import api from '@api';
import utils from '@utils';

export const submit = async (
  event: any,
  stripe: any,
  elements: any,
  CardNumberElement: any,
  setLoading: any,
  history: any,
  me: MeStore,
  actions: MeAction,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setLoading(true);

  if (!stripe || !elements) {
    // Stripe.js has not loaded yet. Make sure to disable
    // form submission until Stripe.js has loaded.
    return;
  }

  try {
    // StripeElementsからカード情報を取得
    const cardNumberElement = elements.getElement(CardNumberElement);

    // StripeAPIからTokenを取得
    const {error, token} = await stripe.createToken(cardNumberElement);

    if (error) {
      console.error(error);
      notify('カードの入力情報に誤りがあります', 'error');
    } else {
      // カード情報が正常であれば、カスタマーを登録
      const t = token.id;
      let b: PaymentCreateCustomerBody = {
        teamId: me.teamId,
        token: t,
      };

      // 既にカスタマーが作成済みかを判定 (作成済みであれば、カードを追加するのみの処理)
      if (me.customerId) {
        const input: PaymentUpdateCustomerBody = {
          token: t,
          customerId: me.customerId,
        };
        await api.payments.createCard(input);
      } else {
        await api.payments.createCustomer(b);
      }

      // meを更新
      await actions.me.updateMe();

      notify('クレジットカードを登録しました', 'success');
      history.push(paths.myPage.main);
    }
  } catch (error) {
    utils.stripe.getErrors(error.response.data);
  } finally {
    setIsModal(false);
    setLoading(false);
  }
};
